window.addEventListener("load", function () {
	if (window.innerWidth > 1024) {
		document
			.querySelectorAll(".major-page-infographic .infographic-item")
			.forEach(function (el) {
				let thisNumberEl = el.querySelector(".info-number");
				let nextNumberEl = el.nextElementSibling
					? el.nextElementSibling.querySelector(".info-number")
					: null;
				let thisHeight = thisNumberEl.getBoundingClientRect().height;
				if (nextNumberEl) {
					let distance =
						el.getBoundingClientRect().top -
						el.nextElementSibling.getBoundingClientRect().top;
					let line = new LeaderLine(thisNumberEl, nextNumberEl, {
						endPlug: "disc",
						endPlugSize: 2,
						startPlug: "disc",
						startPlugSize: 2,
						color: "rgba(155,30,33)",
						size: 2,
						dash: {
							gap: 8,
						},
						startSocket: "bottom",
						endSocket: "top",
						startSocketGravity: [
							-50,
							-(distance + thisHeight) * 1.35,
						],
						endSocketGravity: [-25, distance / 3],
					});
					window.addEventListener(
						"resize",
						function () {
							line.position();
						},
						false
					);
				}
			});
		document
			.querySelectorAll(".laos-page-infographic .infographic-item")
			.forEach(function (el) {
				let thisNumberEl = el.querySelector(".info-number");
				let nextNumberEl = el.nextElementSibling
					? el.nextElementSibling.querySelector(".info-number")
					: null;
				let thisHeight = thisNumberEl.getBoundingClientRect().height;
				if (nextNumberEl) {
					let distance =
						el.getBoundingClientRect().top -
						el.nextElementSibling.getBoundingClientRect().top;
					let line = new LeaderLine(thisNumberEl, nextNumberEl, {
						endPlug: "disc",
						endPlugSize: 2,
						startPlug: "disc",
						startPlugSize: 2,
						color: "rgba(155,30,33)",
						size: 2,
						dash: {
							gap: 8,
						},
						startSocket: "bottom",
						endSocket: "top",
						startSocketGravity: [
							-50,
							-(distance + thisHeight) * 1.25,
						],
						endSocketGravity: [-25, distance / 3],
					});
					window.addEventListener(
						"resize",
						function () {
							line.position();
						},
						false
					);
				}
			});
	}
});
